import type { ProductWithEnrichedPrice } from "@store/types/ProductWithEnrichedPrice.types";
import type { ServerData } from "@store/types/ServerData.types";

import type { PaymentData } from "@jti/fe-common";
import type { Order } from "@jti/magento";

export type OrderState = {
  orderNumber?: string;
  orderDetails: ServerData<Order | null>;
  contactEmail?: string;
  paymentMethod?: PaymentData;
  points: number;
};

export type FormattedOrder = Omit<Order, "items"> & {
  items: ProductWithEnrichedPrice[];
};
